import {addPrefillEmail} from "@/composables/prefillEmail";

// A link to the fullstack (#register, #pre-register…). Staging and local use Clerk's development
// instance, whose session is kept per site, so the link has to carry it: Clerk's
// buildUrlWithAuth adds the dev-browser token. Production shares one session across *.vizbi.org,
// and the URL comes back unchanged. Only for the fullstack, never external sites.
// An email link's address, kept for the tab, goes along (prefillEmail.js; 2026-10-27).
export function getUrlWithAuth(url) {
  const withEmail = addPrefillEmail(url);
  return window.Clerk?.buildUrlWithAuth?.(withEmail) || withEmail;
}
